import { Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PlanDocumentItem } from '../../../types';
import { usePlanDocumentUpdateMutation } from '../../../services/planDocuments';

interface PlanDocumentEditDialogProps {
	open: boolean;
	onClose: () => void;
	planDocument: PlanDocumentItem | null;
}

export const PlanDocumentEditDialog = ({ open, onClose, planDocument }: PlanDocumentEditDialogProps) => {
	const [planDocumentUpdateMutation] = usePlanDocumentUpdateMutation();
	const [errorMessage, setErrorMessage] = useState<string | null>(null);
	const [cachedDocument, setCachedDocument] = useState<PlanDocumentItem | null>(null);

	useEffect(() => {
		if (planDocument) {
			setCachedDocument(planDocument);
		}
	}, [planDocument]);

	const handleEditPlanDocument = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!planDocument) {
			return;
		}
		const formData = new FormData(e.target as HTMLFormElement);
		planDocumentUpdateMutation({id: planDocument.id, formData}).unwrap().catch((error) => {
			setErrorMessage((error as any)?.data?.message ?? 'Failed to update document');
		});
		onClose();
	};

	return <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
		<DialogTitle>Edit Document</DialogTitle>
		{cachedDocument ? (
			<form onSubmit={handleEditPlanDocument}>
				<DialogContent>
					<Box display='flex' flexDirection='column' gap={1}>
						<TextField disabled fullWidth autoComplete='off' label='Name' name='name' value={cachedDocument.name} />
						{errorMessage && (
							<Box mt={1}>
								<TextField
									disabled
									fullWidth
									variant='standard'
									value={errorMessage}
									error
								/>
							</Box>
						)}
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>Cancel</Button>
					<Button variant='contained' type='submit'>Save</Button>
				</DialogActions>
			</form>
		) : null
		}
	</Dialog>;
};